import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Question & Answers ", -1 /* HOISTED */)
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = ["checked", "disabled", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_8 = { key: 6 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Answer protected from edit", -1 /* HOISTED */)
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 4 }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, "No questions exists for this scan and the service", -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]

import {ref, onBeforeMount} from "vue";
import {useRoute} from "vue-router";
import ScanModel from "../model/ScanModel"
import messageModel from "../model/MessageModel"
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditScanComponent',
  props: {
  scanId : {
    type: [Number, String],
    required: true
  },
  userId : {
    type: [Number, String],
    required: false
  },
  token : {
    type: String,
    default: ''
  },
  authentication : {
    type: String,
    default: ''
  },
  onSuccess : {
    type: Function,
  },
  onError : {
    type: Function,
  },
  onCancel : {
    type: Function,
  },
},
  setup(__props) {

const props = __props;

const isLoading = ref(true);
const isError = ref(false);
const scan = ref(null);
const scanValue = ref('');
const existScanId = ref(null);
const udid = ref(null);
const serviceId = ref(null);
const totalCount = ref(0);
const errorMessageExist = ref(false);
const errorMessage = ref('');
const allScanAnswers = ref({});
const questionIds = ref([]);
const allQA = ref([]);
const answerCheckB = ref([]);
const allowedQaTypes = ref([
  'option', 'manual', 'manualnumeric', 'manualmultiline', 'checkbox', 'dropdown', 'barcode', 'barcodenumeric', 'barcodemultiline', 'webcollect'
]);
const answerOption = ref({});
const answerCheckbox = ref({});
const answerDropdown = ref({});
const ansWebcollect = ref({});
const scanModel = ref(null);

onBeforeMount(async ()=> {
  scanModel.value = new ScanModel();
  await load();
})

async function load() {
  let scanParams = {
    scan_id: props.scanId,
    user_id: "all",
    deleted_users: "true"
  };

  if (props.authentication != 'api_key') {
    scanParams['token'] = props.token;
  }

  let scanResponse = await scanModel.value.retrieve(scanParams);
  if (scanResponse.status == 1) {
    if (scanResponse.count == 0 ) {
      if (props.onError) {
        props.onError(292);
        isError.value = true;
        isLoading.value = false;
      } else {
        messageModel.getById(292).then((message) => {
          errorMessageExist.value = true;
          errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';
        });
        isLoading.value = false;
      }

      return false;
    }
    scan.value = scanResponse.scan[0];
    scanValue.value = scan.value.tid;
    existScanId.value = scan.value._id;
    for (let scan of scanResponse.scan) {
      serviceId.value = scan.service._id;
      if (typeof scan.answer != 'undefined') {
        for (let ans of scan.answer) {
          if (typeof allScanAnswers.value[ans._qid] == 'undefined'){
            allScanAnswers.value[ans._qid] = [];
          }
          allScanAnswers.value[ans._qid].push(ans.__text);
          questionIds.value.push(ans._qid);
        }

      }
    }
  } else {
    if (props.onError) {
      props.onError(scanResponse.error._code);
      isError.value = true;
      isLoading.value = false;
    } else {
      messageModel.getById(scanResponse.error._code).then((message) => {
        errorMessageExist.value = true;
        errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';;
      });
      isLoading.value = false;
    }

    return false;
  }

  if (scan.value != null) {
    let scananswerResponse = await scanModel.value.retrieveAnswer(scanParams);

    if (scananswerResponse.status == 1) {
      udid.value = scananswerResponse.udid;
      //this.userId = scananswerResponse.user_id;
      allQA.value = scananswerResponse.question;
      totalCount.value = allQA.value.length;

      for (let allqa of allQA.value) {
        allqa['answerObj'] = [];
        if (allqa.type == 'webcollect') {
          if (!Array.isArray(ansWebcollect.value[allqa.question_id])) {
            ansWebcollect.value[allqa.question_id] = [];
          }
        }

        if (allqa.type == 'checkbox') {
          if (!Array.isArray(answerCheckbox.value[allqa.question_id])) {
            answerCheckbox.value[allqa.question_id] = [];
          }
        }

        for (let ans of allqa['answer']) {
          let ansArr = {};
          let text = ans;
          ansArr['text'] = ans;
          ansArr['type'] = '';
          ansArr['link'] = '';
          ansArr['file'] = '';

          if (text != undefined  && text != ' ') {
            if (text.substr(0, 6) == 'geo://') {
              let t = (text.substr(6)).split(',');
              ansArr['text'] = t[0] + ',' + t[1];
              ansArr['type'] = 'geo';
            } else if (text.substr(0, 8) == '<dropbox') {
              text  = text.replace(/\\/g, ' ');
              let existLink = /link=\"([^\s]+)\"/.exec(text);
              let existFile = /file=\"([^\s]+)\"/.exec(text);
              ansArr['type'] = 'dropbox';
              ansArr['link'] = existLink != null ? existLink[1] : '';
              ansArr['file'] = existFile ? existFile[1] : '';
            } else if (text.substr(0, 21) == 'data:image/png;base64') {
              ansArr['text'] = text.replace(/\\/g, '');
              ansArr['type'] = 'base64';
            } else if (text.indexOf('{') == 0) {
              try {
                let jsonAns = JSON.parse(text);
                ansArr['type'] = 'json';
                ansArr['link'] = jsonAns.link;
                ansArr['file'] = jsonAns.filename;
              } catch (e) {
              }
            }
          } else {
            ansArr['text'] = '';
          }


          allqa['answerObj'].push(ansArr);

          if (typeof allScanAnswers.value[allqa.question_id] !== 'undefined' && allScanAnswers.value[allqa.question_id].includes(ans)) {
            if (allqa.type == 'checkbox') {
              if (!Array.isArray(answerCheckbox.value[allqa.question_id])) {
                answerCheckbox.value[allqa.question_id] = [];
              }
              if (ans != '') {
                answerCheckbox.value[allqa.question_id].push(ans);
              }
            }

            if (allqa.type == 'option') {
              if (ans != '') {
                answerOption.value[allqa.question_id] = ans;
              }
            }
            if (allqa.type == 'dropdown') {
              answerDropdown.value[allqa.question_id] = ans ;
            }
            if (allqa.type == 'webcollect') {
              ansWebcollect.value[allqa.question_id].push(ans) ;
            }
          }

          if (allqa.type == 'barcodenumeric' || allqa.type == 'manualnumeric') {
            allqa['answer'][0] = ans;
          }
        }
      }
    } else {
      if (props.onError) {
        isError.value = true;
        props.onError(scananswerResponse.error._code);
      } else {
        messageModel.getById(scananswerResponse.error._code).then((message) =>{
          errorMessageExist.value = true;
          errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';
        });

      }
      isLoading.value = false;
      return false;
    }
  }
  isLoading.value = false;
}

function historyBack() {
  if (props.onCancel) {
    props.onCancel();
  } else {
    window.history.back();
  }
}

function checkAnswer(questionId, answer) {
  if (!Array.isArray(answerCheckbox.value[questionId])) {
    answerCheckbox.value[questionId] = [];
  }
  if(answerCheckbox.value[questionId].indexOf(answer) > -1) {

    let answers = [];
    for (let a of answerCheckbox.value[questionId]) {
      if (a != answer) {
        answers.push(a);
      }
    }
    answerCheckbox.value[questionId] = answers;
  } else {
    answerCheckbox.value[questionId].push(answer);
  }
}

async function update() {
  isLoading.value = true;

  let answerForUpdate = {};
  let isAnswerError = false;

  for (let question of allQA.value) {
    let key = question.question_id;
    key = key.toString();

    if (question.answer != undefined) {
      if (question.type == 'checkbox') {
        if (answerCheckbox.value[question.question_id].length == 0 && question.is_required == '1') {
          isAnswerError = true;
        }
        if (answerCheckbox.value[question.question_id].length > 0) {
          answerForUpdate[key] = answerCheckbox.value[question.question_id].join('|^|');
        }
      } else if (question.type == 'option') {
        if (answerOption.value[question.question_id] == '' && question.is_required == '1') {
          isAnswerError = true;
        }
        if (answerOption.value[question.question_id] != '') {
          answerForUpdate[key] = answerOption.value[question.question_id];
        }
      } else if (question.type == 'dropdown') {
        if (answerDropdown.value[question.question_id] == '' && question.is_required == '1') {
          isAnswerError = true;
        }
        if (answerDropdown.value[question.question_id] != '') {
          answerForUpdate[key] = answerDropdown.value[question.question_id];
        }
      } else if (question.type == 'webcollect') {
        answerForUpdate[key] = ansWebcollect.value[question.question_id].join('|^|');
      } else {

        if ((typeof question.answer == 'undefined' || question.answer[0] == null || question.answer[0] == '') && question.is_required == '1') {
          isAnswerError = true;
        }
        if (typeof question.answer != 'undefined') {
          answerForUpdate[key] = question.answer[0];
        }
      }
    }
  }

  if (isAnswerError) {
    if (props.onError) {
      props.onError(2548);
    } else {
      messageModel.getById(2548).then((message) => {
        errorMessageExist.value = true;
        errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';;
      });

    }
    isLoading.value = false;
  } else {
    let currentDate = moment().format('YYYY-MM-DD HH:mm:ss');

    let ssparams = {
      token: props.token,
      scanid: parseInt(String(props.scanId)),
      sid: serviceId.value,
      udid: udid.value,
      userid: props.userId,
      scan_updated: currentDate,
      manual_update: 1
    };
    if (props.authentication != 'api_key') {
      ssparams.token = props.token;
    }
    answerForUpdate = JSON.stringify(answerForUpdate);
    let secureScanResponse = await scanModel.value.securescan(ssparams, answerForUpdate);
    if (secureScanResponse.message.status == 1 || secureScanResponse.message.status == -1) {
      if (props.onSuccess) {
        props.onSuccess(2487);
      }
      isLoading.value = false;
    } else {
      if (props.onSuccess) {
        props.onSuccess(secureScanResponse.message.text);
      }
      isLoading.value = false;
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(_component_spinner, {
          key: 0,
          text: "Loading, please wait..."
        }))
      : _createCommentVNode("v-if", true),
    (errorMessageExist.value)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 1,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(errorMessage.value), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (!isLoading.value && !isError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (update()), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_textarea, {
                          variant: "outlined",
                          density: "compact",
                          label: "Value",
                          modelValue: scanValue.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((scanValue).value = $event)),
                          rows: "3",
                          readonly: ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createVNode(_component_v_divider, { class: "my-2" }),
                      _hoisted_2,
                      _createVNode(_component_v_divider, { class: "my-2" }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allQA.value, (qa) => {
                        return (_openBlock(), _createBlock(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { md: "3" }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", _hoisted_3, _toDisplayString(qa.question), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createVNode(_component_v_col, { md: "9" }, {
                              default: _withCtx(() => [
                                (qa.type == 'manual' || qa.type == 'barcode')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass({'has-error':!qa.answer[0] && qa.is_required == '1'})
                                    }, [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_v_text_field, {
                                          variant: "outlined",
                                          density: "compact",
                                          modelValue: qa.answer[0],
                                          "onUpdate:modelValue": ($event: any) => ((qa.answer[0]) = $event),
                                          disabled: qa.is_active == 0,
                                          hint: qa.is_active == 0 ? 'This question is currently inactive' : ''
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "hint"])
                                      ])
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (qa.type == 'manualnumeric' || qa.type == 'barcodenumeric')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass({'has-error':!qa.answer[0] && qa.is_required == '1'})
                                    }, [
                                      _createElementVNode("div", null, [
                                        _createTextVNode(_toDisplayString(typeof qa.answer[qa.question_id] !='undefined' ? qa.answer[qa.question_id][0] : '') + " ", 1 /* TEXT */),
                                        _createVNode(_component_v_text_field, {
                                          variant: "outlined",
                                          density: "compact",
                                          type: "number",
                                          pattern: "[0-9]+([\\.,][0-9]+)?",
                                          step: "any",
                                          modelValue: qa.answer[0],
                                          "onUpdate:modelValue": ($event: any) => ((qa.answer[0]) = $event),
                                          disabled: qa.is_active == 0,
                                          hint: qa.is_active == 0 ? 'This question is currently inactive' : ''
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "hint"])
                                      ])
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (qa.type == 'manualmultiline' || qa.type == 'barcodemultiline')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      class: _normalizeClass({'has-error':!qa.answer[0] && qa.is_required == '1'})
                                    }, [
                                      _createElementVNode("div", null, [
                                        _createTextVNode(_toDisplayString(typeof qa.answer[qa.question_id] !='undefined' ? qa.answer[qa.question_id][0] : '') + " ", 1 /* TEXT */),
                                        _createVNode(_component_v_textarea, {
                                          variant: "outlined",
                                          density: "compact",
                                          modelValue: qa.answer[0],
                                          "onUpdate:modelValue": ($event: any) => ((qa.answer[0]) = $event),
                                          disabled: qa.is_active == 0,
                                          hint: qa.is_active == 0 ? 'This question is currently inactive' : ''
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "hint"])
                                      ])
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (qa.type == 'option')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 3,
                                      class: _normalizeClass({'has-error':!answerOption.value[qa.question_id] && qa.is_required == '1'})
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.answer, (answer) => {
                                        return (_openBlock(), _createElementBlock("div", null, [
                                          (answer !== '')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createVNode(_component_v_radio_group, {
                                                  modelValue: answerOption.value[qa.question_id],
                                                  "onUpdate:modelValue": ($event: any) => ((answerOption.value[qa.question_id]) = $event),
                                                  density: "compact",
                                                  "hide-details": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_radio, {
                                                      value: answer,
                                                      label: _ctx.$capitalize(answer),
                                                      disabled: qa.is_active === 0,
                                                      name: 'answerOption_' + qa.question_id
                                                    }, null, 8 /* PROPS */, ["value", "label", "disabled", "name"])
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      }), 256 /* UNKEYED_FRAGMENT */)),
                                      (qa.is_active == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "This question is currently inactive"))
                                        : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (qa.type == 'checkbox')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 4,
                                      class: _normalizeClass({'has-error':answerCheckbox.value[qa.question_id].length == 0 && qa.is_required == '1'})
                                    }, [
                                      _createElementVNode("div", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.answer, (answer) => {
                                          return (_openBlock(), _createElementBlock("div", null, [
                                            (answer != '')
                                              ? (_openBlock(), _createElementBlock("input", {
                                                  key: 0,
                                                  type: "checkbox",
                                                  checked: typeof allScanAnswers.value[qa.question_id] !='undefined' && allScanAnswers.value[qa.question_id].indexOf(answer) > -1,
                                                  disabled: qa.is_active == 0,
                                                  onClick: ($event: any) => (checkAnswer(qa.question_id, answer))
                                                }, null, 8 /* PROPS */, _hoisted_6))
                                              : _createCommentVNode("v-if", true),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$capitalize(answer)), 1 /* TEXT */)
                                          ]))
                                        }), 256 /* UNKEYED_FRAGMENT */)),
                                        (qa.is_active == 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "This question is currently inactive"))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (qa.type == 'dropdown')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 5,
                                      class: _normalizeClass({'has-error':Object.keys(answerDropdown.value).length > 0 && answerDropdown.value[qa.question_id].length == 0 && qa.is_required == '1'})
                                    }, [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_v_select, {
                                          variant: "outlined",
                                          density: "compact",
                                          modelValue: answerDropdown.value[qa.question_id],
                                          "onUpdate:modelValue": ($event: any) => ((answerDropdown.value[qa.question_id]) = $event),
                                          items: qa.answer,
                                          disabled: qa.is_active === 0,
                                          "item-text": "text",
                                          "item-value": "value",
                                          "hide-details": "",
                                          hint: qa.is_active == 0 ? 'This question is currently inactive' : '',
                                          label: "Please select"
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "items", "disabled", "hint"])
                                      ])
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (qa.type == 'webcollect')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      (qa.answer.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.answer, (answer) => {
                                              return (_openBlock(), _createElementBlock("div", null, [
                                                _createVNode(_component_v_textarea, {
                                                  variant: "outlined",
                                                  density: "compact",
                                                  modelValue: ansWebcollect.value[qa.question_id],
                                                  "onUpdate:modelValue": ($event: any) => ((ansWebcollect.value[qa.question_id]) = $event),
                                                  disabled: ""
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (qa.answer.length <= 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.answer, (answer) => {
                                              return (_openBlock(), _createElementBlock("div", null, [
                                                _createVNode(_component_v_textarea, {
                                                  modelValue: ansWebcollect.value[qa.question_id],
                                                  "onUpdate:modelValue": ($event: any) => ((ansWebcollect.value[qa.question_id]) = $event),
                                                  disabled: ""
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      _hoisted_11
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (allowedQaTypes.value.indexOf(qa.type) <= -1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      (typeof qa.answerObj[0] !='undefined' && qa.answerObj[0].type == 'geo')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createElementVNode("a", {
                                              href: 'https://maps.google.com?q=' + qa.answerObj[0].text,
                                              target: "_blank",
                                              class: "text-black"
                                            }, [
                                              _createElementVNode("small", null, [
                                                _createVNode(_component_v_icon, { icon: "mdi-dock-window" })
                                              ]),
                                              _createTextVNode(" Click to view ")
                                            ], 8 /* PROPS */, _hoisted_14)
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (typeof qa.answerObj[0] !='undefined' && (qa.answerObj[0].type == 'dropbox') && qa.answerObj[0].link != '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("a", {
                                                href: qa.answerObj[0].link,
                                                target: "_blank"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: qa.answerObj[0].link,
                                                  class: "maxWDropbox img-thumbnail",
                                                  alt: "max dropbox"
                                                }, null, 8 /* PROPS */, _hoisted_17)
                                              ], 8 /* PROPS */, _hoisted_16),
                                              _hoisted_18
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (typeof qa.answerObj[0] !='undefined' && (qa.answerObj[0].type == 'json') && qa.answerObj[0].link != '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("a", {
                                                href: qa.answerObj[0].link,
                                                target: "_blank",
                                                class: "text-black"
                                              }, "View Image", 8 /* PROPS */, _hoisted_20)
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (typeof qa.answerObj[0] !='undefined' && qa.answerObj[0].type == 'base64')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("img", {
                                                src: qa.answerObj[0].text,
                                                class: "maxWBase64 img-thumbnail",
                                                alt: "max Wbase"
                                              }, null, 8 /* PROPS */, _hoisted_22)
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (typeof qa.answerObj[0] !='undefined' && qa.answerObj[0].type != 'base64' && qa.answerObj[0].type !='dropbox' && qa.answerObj[0].type !='json' && qa.answerObj[0].type !='geo')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("em", null, _toDisplayString(qa.answer[0] ? qa.answer[0] : "Answer not available"), 1 /* TEXT */)
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "hidden",
                                        "onUpdate:modelValue": ($event: any) => ((qa.answer[0]) = $event)
                                      }, null, 8 /* PROPS */, _hoisted_24), [
                                        [_vModelText, qa.answer[0]]
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      (totalCount.value == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            md: "7",
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                class: "text-none",
                                color: "black",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => {historyBack();})
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cancel")
                                ]),
                                _: 1 /* STABLE */
                              }),
                              (totalCount.value > 0)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    type: "submit",
                                    color: "black",
                                    disabled: isLoading.value,
                                    class: "ml-4 text-none"
                                  }, {
                                    default: _withCtx(() => [
                                      (isLoading.value)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            indeterminate: ""
                                          }))
                                        : _createCommentVNode("v-if", true),
                                      _createTextVNode(" Update ")
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["disabled"]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})